/**
 * Dev Tools Hub — single entry point for all dev/testing screens.
 * DEV-only. No competitive engine interaction.
 */

import { View, Text, StyleSheet, ScrollView, TouchableOpacity } from 'react-native';
import { useRouter } from 'expo-router';
import { useTheme } from '@/contexts/ThemeContext';

const DEV_SCREENS: { label: string; path: string; description: string }[] = [
  {
    label: 'Trainer Dashboard',
    path: '/(dev)/trainer-dashboard',
    description: 'Client list, search, coach insights panels.',
  },
  {
    label: 'Trainer Client Detail',
    path: '/(dev)/trainer-client-detail',
    description: 'Per-client baseline, freshness, workout stats.',
  },
  {
    label: 'Org Dashboard',
    path: '/org-dashboard',
    description: 'Organization membership view.',
  },
  {
    label: 'Workout Templates',
    path: '/(dev)/workout-templates',
    description: 'Coach workout template scaffold.',
  },
  {
    label: 'Pro Debug',
    path: '/dev/pro-debug',
    description: 'Subscription tier, capabilities, gate status.',
  },
  {
    label: 'Pilot QA',
    path: '/(dev)/pilot-qa',
    description: 'Route checklist, flag status, V1 smoke test.',
  },

];

export default function DevToolsScreen() {
  const { theme } = useTheme();
  const c = theme.colors;
  const router = useRouter();

  return (
    <ScrollView style={[styles.container, { backgroundColor: c.background }]}>
      <Text style={[styles.title, { color: c.accent }]}>DEV TOOLS</Text>
      <Text style={[styles.subtitle, { color: c.textSecondary }]}>
        Testing entry points — DEV only
      </Text>

      {DEV_SCREENS.map((screen) => (
        <TouchableOpacity
          key={screen.path}
          style={[styles.card, { backgroundColor: c.surface, borderColor: c.border }]}
          onPress={() => router.push(screen.path as any)}
          activeOpacity={0.7}
        >
          <Text style={[styles.cardLabel, { color: c.text }]}>{screen.label}</Text>
          <Text style={[styles.cardDesc, { color: c.textSecondary }]}>{screen.description}</Text>
          <Text style={[styles.cardPath, { color: c.textTertiary }]}>{screen.path}</Text>
        </TouchableOpacity>
      ))}

      <View style={styles.spacer} />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, padding: 20, paddingTop: 60 },
  title: { fontSize: 24, fontWeight: '900', letterSpacing: 2, marginBottom: 4 },
  subtitle: { fontSize: 14, marginBottom: 20 },
  card: {
    borderWidth: 1,
    borderRadius: 2,
    padding: 16,
    marginBottom: 12,
  },
  cardLabel: { fontSize: 16, fontWeight: '700', marginBottom: 4 },
  cardDesc: { fontSize: 13, marginBottom: 8 },
  cardPath: { fontSize: 11, fontFamily: 'monospace' },
  spacer: { height: 40 },
});
